/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const CardContainer = styled.div`
  width: 300px;
  height: 300px;
  background: red;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  h2 {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 38px;
    line-height: 58px;
    margin-left: 20px;
  }
  :hover {
    transition: opacity 0.3s;  
    opacity: 0.5; 
  }
`;
